import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnreadIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17.423,
	height: 15.681,
	viewBox: "0 0 17.423 15.681",
	fill: "",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6455",
		"data-name": "Path 6455",
		d: "M16.81,8.969a4.338,4.338,0,0,0,2.613-.889v7.858a1.747,1.747,0,0,1-1.742,1.742H3.742A1.747,1.747,0,0,1,2,15.938V5.485A1.747,1.747,0,0,1,3.742,3.742h8.8a4.764,4.764,0,0,0-.087.871,4.332,4.332,0,0,0,1.455,3.232l-3.2,1.995L4.875,6.19a.74.74,0,1,0-.784,1.254L10.25,11.3a.881.881,0,0,0,.923,0l4.155-2.6A4.418,4.418,0,0,0,16.81,8.969ZM14.2,4.613A2.613,2.613,0,1,0,16.81,2,2.61,2.61,0,0,0,14.2,4.613Z",
		transform: "translate(-2 -2)"
	})
});
export { SvgUnreadIcon as ReactComponent };
